/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ca-central-1",
    "aws_cloud_logic_custom": [
        {
            "name": "rcmapAPI",
            "endpoint": "https://qpf02pqbvg.execute-api.ca-central-1.amazonaws.com/dev",
            "region": "ca-central-1"
        },
        {
            "name": "spotifylogin",
            "endpoint": "https://32o9t2ab6f.execute-api.ca-central-1.amazonaws.com/dev",
            "region": "ca-central-1"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://bf3ohwiddnaifpzjy3dgsq5zbe.appsync-api.ca-central-1.amazonaws.com/graphql",
    "aws_appsync_region": "ca-central-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-mduzrhivbvhrthk23ptldkk3ea",
    "aws_cognito_identity_pool_id": "ca-central-1:d9d01780-f492-48ed-9fc3-42fd111a1663",
    "aws_cognito_region": "ca-central-1",
    "aws_user_pools_id": "ca-central-1_eLTW4TpKZ",
    "aws_user_pools_web_client_id": "dic3282sath58iku2g6c0d3uk",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
